export const pdpSpecificVideoLockupComponent = {
  key: 'pdpSpecificVideoLockupComponent',
  name: 'Pdp Specific Video Lockup Component',
  siteIdentifier: 'global',

  learnMoreButton: 'Learn more',
  selectVideoAriaLabel: 'Select video {caption}',
};
